import React from 'react';
import PropTypes from 'prop-types';
import { LocaleService } from '@sm360/widget-commons-core-services';
import { PriceAmounts } from '@sm360/widget-commons-general';
import CurrencyFormats from 'commons-vehicle/constants/currencyFormats.js';

import ReactCollapse from 'react-collapse';
import '../AmountLineItem/AmountLineItem.scss';

const REBATE_CATEGORIES = ['discount', 'rebate', 'tradeIn'];
class AmountLineItem extends React.Component {
    constructor(props) {
        super(props);
        const automaticallyExpand = props?.transactionIndex === 0;
        this.state = {
            showPriceDetails: automaticallyExpand || false,
        };

        this.showPriceDetails = this.showPriceDetails.bind(this);
    }
    showPriceDetails() {
        this.setState((prevState) => {
            return { showPriceDetails: !prevState.showPriceDetails };
        });
    }
    render() {
        const { label, amount, subItem, category, isTotal, isLast } = this.props;
        const isTotalClass = (isTotal && (isLast ? 'price_total' : 'pdsf_total')) || '';
        const classes = `purchase-detail-line clearfix sr-paymentCalculator-EmphasisColor ${
            subItem?.length > 0 ? 'collapsable' : ''
        } ${isTotalClass}`;
        const isRebate = amount < 0 || REBATE_CATEGORIES.includes(category);
        const labelClass = `label ${isRebate ? 'rebate sr-paymentCalculator-EmphasisColor' : 'emphasis'}`;
        const subClass = 'sub';

        return amount >= 0 || (isRebate && amount <= 0) ? (
            <div className="amountLineItem">
                <div className={classes} onClick={subItem.length > 0 && this.showPriceDetails}>
                    <span className={labelClass}>
                        {isRebate && <icon className="icon-promo2 is-util" />}
                        {label}
                    </span>
                    {subItem.length > 0 && (
                        <icon
                            className={
                                this.state.showPriceDetails
                                    ? 'icon-chevron-thin-down collapse-chevron inverted'
                                    : 'icon-chevron-thin-down collapse-chevron'
                            }
                        />
                    )}
                    <span className={`value ${isRebate || isLast ? 'is-util' : ''}`}>
                        <PriceAmounts price={LocaleService.l(amount, CurrencyFormats.CURRENCY_2)} />
                    </span>
                </div>
                {subItem.length > 0 && (
                    <ReactCollapse isOpened={this.state.showPriceDetails}>
                        <ul>
                            {subItem.map((item) => {
                                return item.amount ? (
                                    <li className={subClass}>
                                        <span className="label">{item.description}</span>
                                        <span className={`value ${isRebate || isLast ? 'is-util' : ''}`}>
                                            <PriceAmounts
                                                price={LocaleService.l(item.amount, CurrencyFormats.CURRENCY_2)}
                                            />
                                        </span>
                                    </li>
                                ) : null;
                            })}
                        </ul>
                    </ReactCollapse>
                )}
            </div>
        ) : null;
    }
}

AmountLineItem.defaultProps = {
    subItem: [],
    isTotal: false,
    isLast: false,
    transactionIndex: -1,
    category: '',
};

AmountLineItem.propTypes = {
    label: PropTypes.string.isRequired,
    amount: PropTypes.number.isRequired,
    subItem: PropTypes.array,
    isTotal: PropTypes.bool,
    isLast: PropTypes.bool,
    transactionIndex: PropTypes.number,
    category: PropTypes.string,
};

AmountLineItem.displayName = 'AmountLineItem';

export default AmountLineItem;
